import { render, staticRenderFns } from "./FormDesigner.vue?vue&type=template&id=a496b0f8"
import script from "./FormDesigner.vue?vue&type=script&lang=js"
export * from "./FormDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports